// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5ki-T","icon":"styles_icon__3UkuQ"};